import React from "react";
import AuthPageTemplate from "./AuthPageTemplate";

const personaTheme = {
  background: "bg-[#0346a4]",
  panelBg: "bg-[#e8f2f4]",
  inputBg: "bg-[#c1dbff]",
  accentText: "text-[#0042ab]",
  mutedText: "text-[#0f3f7a]",
  buttonPrimary: "bg-[#0042ab] hover:bg-[#00388a]",
  buttonText: "text-white",
  toggleActiveBg: "bg-[#0042ab]",
  toggleInactiveBg: "bg-transparent",
  toggleActiveText: "text-white",
  toggleInactiveText: "text-[#0042ab]",
  link: "text-[#0042ab] hover:underline",
  mfaBannerBg: "bg-[#0042ab]",
};

const PersonasAuthPage = () => (
  <AuthPageTemplate
    variant="personas"
    theme={personaTheme}
    title="Bienvenido a Mou Personas"
    redirectPath="/personas/dashboard"
  />
);

export default PersonasAuthPage;
